import { LegalLayout, LegalSection, COMPANY } from "../components/LegalLayout";
import { useLanguage } from "../contexts/LanguageContext";

export default function TermsOfService() {
  const { language } = useLanguage();
  if (language === "en") {
    return (
      <LegalLayout title="Terms of Use & Legal Notice" testId="terms-page">
        <LegalSection title="Legal notice">
          <p>Publisher: {COMPANY.name} — No. {COMPANY.siren} — Contact: {COMPANY.email}</p>
        </LegalSection>
        <LegalSection title="Use">
          <p>The app is reserved for adults (18 and over). Any insulting, threatening, illegal or fraudulent content or
            behavior is forbidden and may lead to account suspension.</p>
          <p>Love Connect + has zero tolerance for child sexual abuse and exploitation (CSAE): any such content or behavior
            leads to an immediate permanent ban and a report to the authorities. See our{" "}
            <a href="/child-safety.html" className="text-primary underline" data-testid="terms-child-safety-link">Child Safety Standards</a>.</p>
        </LegalSection>
        <LegalSection title="Credits and subscriptions">
          <p>Credits and subscriptions are digital content usable only within the app. Subscriptions renew automatically
            and can be cancelled at any time from Google Play or your payment account.</p>
        </LegalSection>
        <LegalSection title="Profiles">
          <p>Some profiles are host profiles designed to make first conversations easier.</p>
        </LegalSection>
      </LegalLayout>
    );
  }
  return (
    <LegalLayout title="CGU & Mentions légales" testId="terms-page">
      <LegalSection title="Mentions légales">
        <p>Éditeur : {COMPANY.name} — N° {COMPANY.siren} — Contact : {COMPANY.email}</p>
      </LegalSection>
      <LegalSection title="Utilisation">
        <p>L'application est réservée aux personnes majeures (18 ans et plus). Tout contenu ou comportement insultant,
          menaçant, illégal ou frauduleux est interdit et peut entraîner la suspension du compte.</p>
        <p>Love Connect + applique une tolérance zéro envers les abus sexuels et l'exploitation sexuelle des enfants (CSAE) :
          tout contenu ou comportement de ce type entraîne un bannissement définitif immédiat et un signalement aux autorités.
          Voir nos{" "}<a href="/child-safety.html" className="text-primary underline" data-testid="terms-child-safety-link">normes de sécurité des enfants</a>.</p>
      </LegalSection>
      <LegalSection title="Crédits et abonnements">
        <p>Les crédits et abonnements sont des contenus numériques utilisables uniquement dans l'application. Les
          abonnements se renouvellent automatiquement et sont résiliables à tout moment depuis Google Play ou votre espace
          de paiement.</p>
      </LegalSection>
      <LegalSection title="Profils">
        <p>Certains profils sont des profils d'animation destinés à faciliter les premiers échanges.</p>
      </LegalSection>
    </LegalLayout>
  );
}
